import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateManipulationService } from 'src/app/shared/services/API/pharmacy/template-manipulation.service';

@Component({
  selector: 'app-template-delete-modal',
  templateUrl: './template-delete-modal.component.html',
  styleUrls: ['./template-delete-modal.component.css']
})
export class TemplateDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<TemplateDeleteModalComponent>,
    private templateManipulationService: TemplateManipulationService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteTemplate: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.templateManipulationService.Delete(this.data.idTemplate).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Relatório excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteTemplate: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteTemplate: false}); 
  }
}